import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function SdkPaypalPage() {
  return <DocPageLayout title="Paypal SDK" description="Integrate PayPal as a payment method using the gateway's browser payment flow." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'SDKs'
  }, {
    label: 'Paypal'
  }]} data-id="element-823">
      <h2 className="text-2xl font-bold text-gray-900 mt-6 mb-4" data-id="element-824">Setup</h2>
      <CodeBlock language="JavaScript" title="PayPal Integration" code={`// 1. Create a session on your server
// 2. Initiate browser payment
const response = await fetch('/api/initiate-paypal', {
  method: 'POST',
  body: JSON.stringify({
    apiOperation: "INITIATE_BROWSER_PAYMENT",
    browserPayment: {
      operation: "PAY",
      paymentConfirmation: "CONFIRM_AT_PROVIDER",
      returnUrl: window.location.origin + "/paypal-return"
    },
    order: { amount: "75.00", currency: "USD" },
    sourceOfFunds: {
      type: "BROWSER_PAYMENT",
      provided: { browserPayment: { paymentMethod: "PAYPAL" } }
    }
  })
});

// 3. Redirect to PayPal URL from response
const data = await response.json();
window.location.href = data.browserPayment.redirectUrl;`} data-id="element-825" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-826">
        Supported Operations
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-827">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-828">
          <thead data-id="element-829">
            <tr className="bg-gray-100" data-id="element-830">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-831">
                Operation
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-832">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-833">
            <tr data-id="element-834">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-835">PAY</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-836">
                Authorize and capture in one step
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-837">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-838">AUTHORIZE</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-839">
                Authorize only, capture later
              </td>
            </tr>
            <tr data-id="element-840">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-841">REFUND</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-842">
                Refund a completed PayPal payment
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}